export default {
  relatedCourses: [],
  groups: []
};
